import ProductsSettings from './ProductsSettings';

export default {
  title: 'Products',
  description:
    'Setup various aspects of POS including the visual and behaviour parts.',
  path: '/pos-settings/products',
  component: ProductsSettings,
  rootPath: { name: 'POS Settings', uri: '/pos-settings' },
  subPath: [{ name: 'Products' }],
};
